import { render, staticRenderFns } from "./distributionOrders.vue?vue&type=template&id=0d6ef8d0"
import script from "./distributionOrders.vue?vue&type=script&lang=js"
export * from "./distributionOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports